import { SettingsProps } from '..'
import { GiftQuantityInput, GiftSelector } from '../../../../../../Gift'

export function GiftSettings(props: SettingsProps) {
  const { state: form } = props

  return (
    <div>
      <GiftSelector form={form} />
      <GiftQuantityInput form={form} />
    </div>
  )
}
